import React, {useState, useEffect} from 'react';

const FileUploadComponentLabels = ({value, onChange}) => {

  const [model, setModel] = useState(value || {});

  const setModelAndNotify = newModel => {
    setModel(newModel);
    onChange(newModel);
  };

  useEffect(() => { setModel(value || {}); }, [ value ]);

  return <div>
      <label className="form-label">Component labels</label>
      <div className="row justify-content-end">
          <div className="col-11">
              <div className="mb-3">
                  <input id="componentLabelsBrowse" name="componentLabelsBrowse"
                         className="form-control"
                         value={model.browse || ''}
                         onChange={e => setModelAndNotify({...model, browse: e.target.value})}
                         placeholder="Browse..." />
              </div>
              <div className="mb-3">
                  <input id="componentLabelsBrowse" name="componentLabelsBrowse"
                         className="form-control"
                         value={model.noFileSelected || ''}
                         onChange={e => setModelAndNotify({...model, noFileSelected: e.target.value})}
                         placeholder="No file selected"/>
              </div>
              <div className="mb-3">
                  <input id="componentLabelsBrowse" name="componentLabelsBrowse"
                         className="form-control"
                         value={model.fileSelected || ''}
                         onChange={e => setModelAndNotify({...model, fileSelected: e.target.value})}
                         placeholder="File selected:"/>
              </div>
              <div className="mb-3">
                  <input id="componentLabelsBrowse" name="componentLabelsBrowse"
                         className="form-control"
                         value={model.uploading || ''}
                         onChange={e => setModelAndNotify({...model, uploading: e.target.value})}
                         placeholder="Uploading..."/>
              </div>
          </div>
      </div>
  </div>;

};

export default FileUploadComponentLabels;
